/**
 *   Generated file. Do not edit
 */
import './converter-stream-extension';

import { BodyConverter } from '@iotize/tap/client/api';

import { ScramLoginParams } from './models';
import { ScramLoginResponseBody } from './models';
import { EncryptedIVRequest } from './models';
import { EncryptedIVResponse } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

export class ScramLoginParamsConverter
  implements BodyConverter<ScramLoginParams>
{
  public encode(
    model: ScramLoginParams,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeScramLoginParams(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): ScramLoginParams {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readScramLoginParams();
  }
}

export class ScramLoginResponseBodyConverter
  implements BodyConverter<ScramLoginResponseBody>
{
  public encode(
    model: ScramLoginResponseBody,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeScramLoginResponseBody(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): ScramLoginResponseBody {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readScramLoginResponseBody();
  }
}

export class EncryptedIVRequestConverter
  implements BodyConverter<EncryptedIVRequest>
{
  public encode(
    model: EncryptedIVRequest,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeEncryptedIVRequest(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): EncryptedIVRequest {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readEncryptedIVRequest();
  }
}

export class EncryptedIVResponseConverter
  implements BodyConverter<EncryptedIVResponse>
{
  public encode(
    model: EncryptedIVResponse,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeEncryptedIVResponse(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): EncryptedIVResponse {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readEncryptedIVResponse();
  }
}
